export enum AreaModelDistribution {
    Random = "Random",
    Uniform = "Uniform"
}